// ─── Pending entry-screen spec file handoff (ocn-S816-P0) ───────────────────
// The "I Have a Spec" entry card opens a file picker and, on selection, must
// navigate straight into chat WITHOUT waiting for the upload (spec §B). A
// File object cannot survive a full page reload (sessionStorage can only
// hold strings) but CAN survive an in-app SPA route change, since `go()` is
// just a React state update, not a browser navigation. This tiny in-memory,
// single-use slot is the handoff: the entry card sets it right before
// navigating; SubscriberChat's mount effect takes it (clearing the slot) on
// its very next render.

let pendingFile: File | null = null;

export function setPendingEntrySpecFile(file: File): void {
  pendingFile = file;
}

/** Consumes the pending file, if any. Clears the slot so it is never reused
 * across sessions/remounts. */
export function takePendingEntrySpecFile(): File | null {
  const file = pendingFile;
  pendingFile = null;
  return file;
}
